import { exibirNomeProposta } from './nomenclatura';
import { isFictor } from './perfilFictor';

export const EnumTipoProposta = {
  CARTAO_SACADO: 'CARTAO_SACADO',
  CARTAO_SEM_SAQUE: 'CARTAO_SEM_SAQUE',
  SAQUE_COMPLEMENTAR: 'SAQUE_COMPLEMENTAR',
  SAQUE_REFIN: 'SAQUE_REFIN',
  COMPRA_DIVIDA_SAQUE: 'COMPRA_DIVIDA_SAQUE',
  COMPRA_DIVIDA: 'COMPRA_DIVIDA',
  RENEGOCIACAO: 'RENEGOCIACAO',
  NOVO: 'NOVO',
  PORTABILIDADE: 'PORTABILIDADE',
  REFIN_TRANSFER: 'REFIN_TRANSFER',
  SAQUE_REFIN_EXT: 'SAQUE_REFIN_EXT',
} as const;
export type TipoPropostaValues = keyof typeof EnumTipoProposta;

const TiposProposta: { value: TipoPropostaValues; label: string }[] = isFictor ? [
  { value: EnumTipoProposta.NOVO, label: 'Novo' },
  { value: EnumTipoProposta.COMPRA_DIVIDA, label: 'Compra de Dívida' },
  { value: EnumTipoProposta.SAQUE_REFIN, label: 'Refin' },
  { value: EnumTipoProposta.PORTABILIDADE, label: 'Portabilidade' },
] : [
  { value: EnumTipoProposta.CARTAO_SACADO, label: 'Cartão Sacado' },
  { value: EnumTipoProposta.CARTAO_SEM_SAQUE, label: 'Cartão Sem Saque' },
  { value: EnumTipoProposta.SAQUE_COMPLEMENTAR, label: 'Saque Complementar' },
  { value: EnumTipoProposta.SAQUE_REFIN, label: 'Saque Refin' },
  { value: EnumTipoProposta.SAQUE_REFIN_EXT, label: 'Saque Refin Externo' },
  { value: EnumTipoProposta.NOVO, label: 'Novo' },
  { value: EnumTipoProposta.COMPRA_DIVIDA, label: 'Compra de Dívida' },
  { value: EnumTipoProposta.COMPRA_DIVIDA_SAQUE, label: 'Compra de Dívida Saque' },
];

const getLabelTipoProp = (value: string) => {
  if (isFictor) {
    if (value === 'CARTAO_SACADO' || value === 'CARTAO_SEM_SAQUE') return 'Novo';
    if (value === 'COMPRA_DIVIDA_SAQUE') return 'Compra de Dívida';
  }
  const tipoProposta = TiposProposta.find(prop => prop.value === value);
  return tipoProposta ? tipoProposta.label : (isFictor ? exibirNomeProposta(value) : '');
};

export { TiposProposta, getLabelTipoProp }